import {
  BenchmarksWidget,
  ClosedWonWidget,
  CompanyActivityTopVisitsWidget,
  DirectViewThroughAllocationWidget,
  OpportunityInfluenceTrendWidget,
  PipelineTrendsWidget,
  TrafficEfficiencyWidget,
  WebTrafficBreakdownByCompanySizeWidget,
  WebTrafficBreakdownByIndustryWidget,
  WebTrafficVisitByTypeTrendWidget,
  WebTrafficVisitsByTypeWidget,
} from './widgets';

const WidgetLibrary = {
  BENCHMARKS_WIDGET: BenchmarksWidget,
  CLOSED_WON_WIDGET: ClosedWonWidget,
  COMPANY_ACTIVITY_TOP_VISITS_WIDGET: CompanyActivityTopVisitsWidget,
  OPPORTUNITY_INFLUENCE_TREND_WIDGET: OpportunityInfluenceTrendWidget,
  PIPELINE_TRENDS_WIDGET: PipelineTrendsWidget,
  TRAFFIC_EFFICIENCY_WIDGET: TrafficEfficiencyWidget,
  DIRECT_VIEW_THROUGH_REALLOCATION_WIDGET: DirectViewThroughAllocationWidget,
  TRAFFIC_BREAKDOWN_BY_TYPE_WIDGET: WebTrafficVisitsByTypeWidget,
  TRAFFIC_BREAKDOWN_BY_INDUSTRY_WIDGET: WebTrafficBreakdownByIndustryWidget,
  TRAFFIC_BREAKDOWN_BY_COMPANY_SIZE_WIDGET: WebTrafficBreakdownByCompanySizeWidget,
  TRAFFIC_TRENDS_WIDGET: WebTrafficVisitByTypeTrendWidget,
};

export default WidgetLibrary;
